import React, { useEffect, useState } from "react";
import DMSHeader from "../../DMSHeader/DMSHeader";
import AffectedReportTable from "./AffectedReportTable/AffectedReportTable";
import { getData } from "../../../../Services/Services";
import { getThemeURL } from "../../../../Services/EndPoints";
import "../ReportEnhanced.css";

const AffectedReport = () => {
  const [stateName, setStateName] = useState("");

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const profile = await getData(getThemeURL);
        if (profile && profile.length > 0) {
          setStateName(profile[0].statename || "");
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };
    fetchUserProfile();
  }, []);

  const getTitle = () => {
    const upper = stateName?.toUpperCase();
    if (!stateName) return "Affected Report";
    if (upper === "LADAKH") return "Affected Report - Ladakh (Union Territory)";
    const display =
      stateName.charAt(0).toUpperCase() + stateName.slice(1).toLowerCase();
    return `Affected Report - ${display}`;
  };

  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title={getTitle()} />
      </div>
      <div className="report-table-enhanced">
        <AffectedReportTable stateName={stateName} />
      </div>
    </div>
  );
};

export default AffectedReport;